module.exports = __webpack_public_path__ + "static/media/cm.70e7c755.svg";